export default __webpack_public_path__ + "static/media/jaguar.6902df27.webp";